import { SeoHead } from '@/components/seo-head';
import { TermsOfUseEn } from '@/components/terms-of-use/en';
import { TermsOfUseAr } from '@/components/terms-of-use/ar';
import { TermsOfUseFr } from '@/components/terms-of-use/fr';
import { TermsOfUseEs } from '@/components/terms-of-use/es';
import { getAbsoluteUrl } from '@/utils/get-absolute-url';
import { useLayout } from '@/utils/use-layout';
import { t } from '@lingui/macro';
import { GetServerSidePropsContext, InferGetServerSidePropsType } from 'next';
import { useRouter } from 'next/router';
import { styled } from '@/styles/stitches.config';
import { loadMessages } from '@/utils/i18n';
import { isPresent } from 'ts-is-present';

export async function getServerSideProps(ctx: GetServerSidePropsContext) {
  const baseUrl = getAbsoluteUrl(ctx.req);
  const messages = await loadMessages(ctx.locale);

  return { props: { baseUrl, messages } };
}

const MaxWidth = styled('div', {
  backgroundColor: '$unicef',
  maxWidth: 'calc(35em + $space$6 * 2)',
  marginBlock: '$8',
  marginInline: 'auto',
  paddingInline: '$6',
});

// This page will contain the terms & conditions
export default function TermsConditionsPage(
  props: InferGetServerSidePropsType<typeof getServerSideProps>
) {
  const { baseUrl } = props;
  const pageTitle = t({ id: 'terms-of-use.title', message: 'Terms of Use' });
  const router = useRouter();

  useLayout('blue');

  const termsOfUseAvailableFor = ['ar', 'en', 'es', 'fr'];

  return (
    <>
      <SeoHead baseUrl={baseUrl} pageTitle={pageTitle} />
      <MaxWidth>
        {router.locale === 'ar' && <TermsOfUseAr title={pageTitle} />}
        {router.locale === 'en' && <TermsOfUseEn title={pageTitle} />}
        {router.locale === 'es' && <TermsOfUseEs title={pageTitle} />}
        {router.locale === 'fr' && <TermsOfUseFr title={pageTitle} />}

        {isPresent(router.locale) && !termsOfUseAvailableFor.includes(router.locale) && (
          <TermsOfUseEn title={pageTitle} />
        )}
      </MaxWidth>
    </>
  );
}
